<template>
  <div class="personalization">
    <p>Customize and personalize your experience with these optional settings.</p>

    <form
      class="form"
      ref="personalizationForm"
      @keyup.enter="submit()"
      v-on:submit.prevent=""
    >
      <div class="row row--separator">
        <div class="row__full">
          <FormSelect
            :value="notificationDeliveryTime"
            :options="notificationDeliveryTimeOptions"
            type="select"
            size="md"
            variant="dark"
            ref-name="notificationDeliveryTime"
            :placeholder="notificationDeliveryTime.value"
            :prefilled="true"
            label="At what time will notification emails be sent (UTC)?"
            :altLabel="'Note: Times are in UTC (currently ' + getUTCTime() + ')'"
            :scrollPosition="0"
            iconSize="lg"
            :icon="icon.notificationDeliveryTime"
            :error="errors.notificationDeliveryTime"
            :status="status.notificationDeliveryTime"
            @valueChanged="setFieldValue($event, 'notificationDeliveryTime')"
            @unfocused="validate('notificationDeliveryTime')"
          />
        </div>
      </div>

      <div class="row row--separator">
        <div class="row__full row__center">
          <FormSubmit
            :status="formStatus"
            icon='<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd"><path d="M8 6.012h-6.58l1.935-6.012 1.718 2.223c1.958-1.389 4.346-2.211 6.927-2.211 6.623 0 12 5.377 12 12s-5.377 11.988-12 11.988-12-5.365-12-11.988c0-1.036.132-2.041.379-3h2.079c-.297.947-.458 1.955-.458 3 0 5.52 4.481 10 10 10 5.52 0 10-4.48 10-10 0-5.519-4.48-10-10-10-2.121 0-4.083.668-5.703 1.796l1.703 2.204zm4 1.988c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z"/></svg>'
            @click="submit()"
          >
            {{ formStatus === 'success' ? 'Success' : 'Update settings' }}
          </FormSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FormSelect from '@/components/form/Select.vue'
import FormSubmit from '@/components/form/Submit.vue'
import config from '@/helpers/config'

export default {
  components: {
    FormSelect,
    FormSubmit
  },
  data () {
    return {
      currentView: 'personalization',
      notificationDeliveryTime: { name: '', value: '' },
      notificationDeliveryTimeOptions: config.settings.notificationDeliveryTimeOptions,
      formStatus: 'default',
      errorMessage: '',
      errors: {
        notificationDeliveryTime: false
      },
      status: {
        notificationDeliveryTime: false
      },
      icon: {
        notificationDeliveryTime: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13 12l-.688-4h-.609l-.703 4c-.596.347-1 .984-1 1.723 0 1.104.896 2 2 2s2-.896 2-2c0-.739-.404-1.376-1-1.723zm-1-8c-5.522 0-10 4.477-10 10s4.478 10 10 10 10-4.477 10-10-4.478-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-2-19.819v-2.181h4v2.181c-1.438-.243-2.592-.238-4 0zm9.179 2.226l1.407-1.407 1.414 1.414-1.321 1.321c-.462-.484-.964-.926-1.5-1.328zm-12.679 9.593c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm12 0c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm-6 6c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm-4-2c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm8 0c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm-8-9c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zm8 0c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5z"/></svg>'
      }
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    settings () {
      return this.$store.getters['app/getSettings']
    },
    userSettings () {
      return this.$store.getters['user/getSettings']
    }
  },
  methods: {
    async submit () {
      this.errorMessage = ''

      if (this.validate('all')) {
        this.formStatus = 'loading'

        try {
          if (this.userSettings && this.userSettings.byId['SETTING_NotificationDeliveryTime'].attributes.default === true) {
            let formData = {
              name: 'NotificationDeliveryTime',
              value: this.notificationDeliveryTime.key
            }

            await this.$store.dispatch('user/addSettings', formData)
          } else {
            let formId = this.userSettings.byId.SETTING_NotificationDeliveryTime.id
            let formData = {
              value: this.notificationDeliveryTime.key
            }

            await this.$store.dispatch('user/updateSettings', { 'id': formId, 'data': formData } )
          }

          this.$store.dispatch('user/fetchSettings')
          this.formStatus = 'success'
        } catch (error) {
          /*if (error.data) {
            if (error.data.errors && Array.isArray(error.data.errors)) {
              error.data.errors.forEach(err => {
                this.errors[err.source.pointer] = err.title
                this.errorMessage += err.title + '<br>'
              })
            } else if (error.data.errors) {
              this.errorMessage = error.data.errors.title
            }
          }

          this.formStatus = 'error'*/
        }
        this.formStatus = 'success'
      }
    },
    async fetchSettings () {
      await this.$store.dispatch('user/fetchSettings')
    },
    validate (field) {
      let valid = true

      if (field === 'notificationDeliveryTime' || field === 'all') {
        if (this.notificationDeliveryTime.key === '' || this.notificationDeliveryTime.key === undefined) {
          this.errors.notificationDeliveryTime = 'Required field'
          valid = false
        } else {
          this.errors.notificationDeliveryTime = undefined
        }

        this.status.notificationDeliveryTime = this.errors.notificationDeliveryTime ? 'invalid' : 'valid'
      }

      return valid
    },
    setFieldValue (value, field) {
      this[field] = value
    },
    getUTCTime () {
      let date = new Date()
      let hours = date.getUTCHours()
      let minutes = date.getUTCMinutes()
      let UTCTime = '??:??'

      if (hours && minutes) {
        UTCTime = hours + ':' + minutes
      }

      return UTCTime
    },
    getNotificationDeliveryTime () {
      if (config && this.settings && this.settings.user.NotificationDeliveryTime) {

        config.settings.notificationDeliveryTimeOptions.forEach(check => {
          if (check.key === this.settings.user.NotificationDeliveryTime) {
            this.notificationDeliveryTime = {
              name: check.name,
              value: check.key
            }
          }
        })
      }
    }
  },
  async created () {
    await this.fetchSettings()
    this.getNotificationDeliveryTime()
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

/* TODO: Move these to Settings and use as base (overwrites here only) */
.personalization {
  width: 90%;
  margin: 0 auto;
  text-align: center;

  p {
    @include font('content--md', $white, 0.9);
    width: 90%;
    margin: 1.5rem auto;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--lg', $white, 0.9);
      margin: 1.5rem auto;
    }
  }
}

</style>
